import React from 'react';
import { Link } from 'react-router-dom';
import WonAuctionBadge from './WonAuctionBadge';

class ChitStatusBadge extends React.Component {
  render() {
    const completed = this.props.completed;

    if (completed) {
      return <span className="bg-green-500 text-gray-200 text-xs px-2 py-1 inline-block rounded-full font-semibold tracking-wide uppercase">
        {this.props.t('text.completed')}
      </span>;
    }
    return <span className="bg-red-500 text-gray-200 text-xs px-2 py-1 inline-block rounded-full font-semibold tracking-wide uppercase">
      {this.props.t('text.incomplete')}
    </span>;
  }
}

class RemainingInstallments extends React.Component {
  render() {
    const t = this.props.t;
    const completed = this.props.completed;
    const installmentsRemaining = this.props.installmentsRemaining;

    if (completed) {
      return null;
    }
    return <div className="text-gray-700 text-base">
      <span className="text-gray-900">{installmentsRemaining} </span>
      {t('text.installmentsRemaining', { count: installmentsRemaining })}
    </div>
  }
}

export default class ChitData extends React.Component {
  render() {
    const chit = this.props.chit;
    const t = this.props.t;

    const formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'INR',
      // These options are needed to round to whole numbers if that's what you want.
      minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    const totalAmount = formatter.format(chit.total_members * chit.per_person_amount);

    return <div className="flex justify-center">
      <div className="w-10/12 sm:max-w-xs sm:mx-auto">
        <div className="max-w-sm rounded-md overflow-hidden shadow-lg px-6 py-4 bg-blue-300 mt-4">
          <div className="flex flex-row justify-between mb-2">
            <div className="flex flex-col font-bold w-8/12 break-words text-gray-800 text-base mr-1">
              {chit.chit_name}
            </div>
            <div className="flex flex-col">
              <ChitStatusBadge completed={chit.is_completed} t={t} />
            </div>
          </div>
          <div className="text-indigo-600 text-2xl">
            {totalAmount}
            <WonAuctionBadge showBadge={chit.won_installment_number != null} />
          </div>
          <div className="text-gray-700 text-base">
            <span className="text-gray-900">{chit.total_members}</span> {t('text.chitDetailMembers')}
          </div>
          <RemainingInstallments completed={chit.is_completed} installmentsRemaining={chit.total_members - (chit.next_installment_count - 1)} t={t} />
          <div className="text-gray-700 text-base">
            {/* Once in <span className="text-gray-900">{chit.auction_interval} month(s)</span> */}
            {t('text.interval', { frequency: t('text.intervalMonth', { count: chit.auction_interval }) })}
          </div>
          <Link to={`/chit/${chit.id}/edit`}>
            <div className="flex flex-row justify-center mt-2">
              <button className="bg-blue-500 hover:bg-blue-700 text-gray-100 font-bold py-2 px-4 rounded-full inline-flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                  <path fillRule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clipRule="evenodd" />
                </svg>
                <span>{t('button.editChit')}</span>
              </button>
            </div>
          </Link>
        </div>
      </div>
    </div>
  }
}
